import { FormAPI } from '@brg/api';
import { useEffect, useState } from 'react';
export var useFormsList = function (id) {
    var _a = useState([]), forms = _a[0], setForms = _a[1];
    var fetchForms = function (id) {
        //@ts-ignore
        FormAPI.GetList({
            // formIds: ids,
            //@ts-ignore
            teamIds: [id],
            limit: 100,
            page: 1
        })
            .then(function (r) {
            return r.json();
        })
            //@ts-ignore
            .then(function (r) { return setForms(r === null || r === void 0 ? void 0 : r.data); });
    };
    useEffect(function () {
        if (!!(id === null || id === void 0 ? void 0 : id.length)) {
            fetchForms(id);
        }
    }, [id]);
    return forms;
};
//# sourceMappingURL=useFormsList.js.mapimport { FormAPI } from '@brg/api';
import { useEffect, useState } from 'react';
export var useFormsList = function (id) {
    var _a = useState([]), forms = _a[0], setForms = _a[1];
    var fetchForms = function (id) {
        //@ts-ignore
        FormAPI.GetList({
            // formIds: ids,
            //@ts-ignore
            teamIds: [id],
            limit: 100,
            page: 1
        })
            .then(function (r) {
            return r.json();
        })
            //@ts-ignore
            .then(function (r) { return setForms(r === null || r === void 0 ? void 0 : r.data); });
    };
    useEffect(function () {
        if (!!(id === null || id === void 0 ? void 0 : id.length)) {
            fetchForms(id);
        }
    }, [id]);
    return forms;
};
//# sourceMappingURL=useFormsList.js.map